export const enum TripOverviewModalType {
  AddFlights = 'addFlights',
  ContinueWithSuggestedDate = 'continueWithSuggestedDate',
  DestinationSelector = 'destinationSelector',
  EditTrip = 'editTrip',
  ExternalError = 'externalError',
  FerryDetails = 'ferryDetails',
  FerryMultipleVehicles = 'ferryMultipleVehicles',
  FlightDetails = 'flightDetails',
  None = 'none',
  PortSelector = 'portSelector',
  PremadeTripDescription = 'premadeTripDescription',
  PriceBreakdown = 'priceBreakdown',
  PriceGuarantee = 'priceGuarantee',
  RemoveDestination = 'removeDestination',
  WhyWeSuggest = 'whyWeSuggest',
  DisneylandCampaign = 'disneylandCampaign',
}
